import { AccountContext } from '@/presentation/contexts/auth/account-provider'
import { useContext } from 'react'

export default function useAccount() {
  const value = useContext(AccountContext)
  if (!value) {
    throw new Error('useAccount must be used within an AccountProvider')
  }
  return value
}
